import * as t from "io-ts";
import nullable from "./nullable";
import isoDateTimeForJSON from "./isoDateTimeForJSON";
import { cargoTypeT } from "./types";
import optional from "./optional";
import { withFallback } from "io-ts-types";
export const locationT = t.strict({
    lat: t.number,
    lon: t.number,
    accuracy: t.number,
});
export const addCargoResponseT = t.strict({
    cargoId: t.string,
    pickupId: t.string,
    deliveryId: t.string,
});
export const createDriverAddCargoTypes = ({ decimal, }) => {
    const stopT = t.strict({
        placeName: t.string,
        address: nullable(t.string),
        city: nullable(t.string),
        postcode: nullable(t.string),
        country: nullable(t.string),
        position: t.intersection([
            t.strict({
                lon: t.number,
                lat: t.number,
            }),
            t.partial({
                accuracy: nullable(t.number),
            }),
        ]),
    });
    const createCargoT = t.strict({
        sessionId: withFallback(nullable(t.string), null),
        routeId: withFallback(nullable(t.string), null),
        truckId: withFallback(nullable(t.string), null),
        pickupTime: isoDateTimeForJSON,
        dropoffDate: t.string,
        cargo: t.strict({
            type: cargoTypeT,
            lm: decimal,
            description: t.string,
        }),
        pickup: stopT,
        dropoff: nullable(stopT),
        clientId: nullable(t.string),
        invoiceRef: optional(t.string),
        position: optional(locationT),
    });
    const addDropoffT = t.intersection([
        stopT,
        t.strict({
            lm: decimal,
            time: isoDateTimeForJSON,
            sessionId: t.string,
            driverPosition: nullable(locationT),
            revision: t.string,
        }),
    ]);
    const addDropoffNoSessionT = t.intersection([
        stopT,
        t.strict({
            lm: decimal,
            time: isoDateTimeForJSON,
            truckId: t.string,
            driverPosition: nullable(locationT),
            revision: t.string,
        }),
    ]);
    return {
        stopT,
        createCargoT,
        addDropoffT,
        addDropoffNoSessionT,
    };
};
//# sourceMappingURL=driver-add-cargo.js.map